module.exports = __webpack_public_path__ + "img/_male-ico.3fe23519.svg";